import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { apiGet } from '../../lib/api.js';
import { useAuth } from '../../store/auth.js';

export const AGREEMENT_PATH = '/onboarding/producer-agreement';
const EXEMPT_ROLES = ['superadmin', 'platform_owner'];

/**
 * App-shell gate: until the Producer Agreement is signed every route redirects to
 * Phone Setup, where the agreement is signed inline (never the dashboard).
 * Fails open if the status lookup errors, and skips platform roles / pending approvals.
 * @param {{children: React.ReactNode}} props
 * @returns {JSX.Element}
 */
export default function AgreementGate({ children }) {
  const agent = useAuth((s) => s.agent);
  const { pathname } = useLocation();
  const exempt = !agent || EXEMPT_ROLES.includes(agent.role) || agent.status === 'pending_approval' || agent._id === 'demo';
  const { data, isLoading } = useQuery({
    queryKey: ['producer-agreement'],
    queryFn: () => apiGet('/onboarding/producer-agreement'),
    enabled: !exempt,
    staleTime: 30_000,
    retry: false,
  });
  if (exempt || pathname.startsWith(AGREEMENT_PATH) || pathname.startsWith('/phone-setup')) return children;
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-civix-bg text-white/50"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  }
  if (data && data.alreadySigned === false) {
    return <Navigate to="/phone-setup" replace />;
  }
  return children;
}
